import React, { InputHTMLAttributes, forwardRef } from 'react';
import { cx } from 'emotion';
import { useSinglelineStyles } from './styles';

export interface SinglelineTextFieldProps
  extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
}

const SinglelineTextField = forwardRef<
  HTMLInputElement,
  SinglelineTextFieldProps
>((props, ref) => {
  const { className, ...rest } = props;
  const styles = useSinglelineStyles();

  return (
    <input
      ref={ref}
      className={className ? cx(className, styles.textField) : styles.textField}
      {...rest}
    />
  );
});

export default SinglelineTextField;
